import React from 'react';
import { Link } from 'react-router-dom';
import './FooterLinks.css';

const FooterLinks = () => {
  return (
    <div className="footer-links">
      <div className="footer-links-container">
        <Link to="/privacy-policy">Privacy Policy</Link>
        <Link to="/terms-and-conditions">Terms & Conditions</Link>
        <Link to="/compliance-policy">Compliance Policy</Link>
        <Link to="/pii-policy">PII Policy</Link>
      </div>
    </div>
  );
};

export default FooterLinks;

